
























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PemantauanAnestesiSvc from "@/services/PemantauanAnestesiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({ components: { VCDateTimePicker } })
export default class PemantauanAnestesiObatCairan extends Vue {
  @Prop() pemantauan!: any;
  @Prop({ default: false }) readonly!: boolean;

  dialogObat = false;
  editingObat: any = null;
  obatValid = false;
  savingObat = false;
  dirty = false;

  obatForm: any = {
    waktu: "", nama_obat: "", dosis: "", rute: "iv_bolus",
    kecepatan_drip: "", keterangan: "",
  };

  cairanMasuk: any = { kristaloid_ml: 0, koloid_ml: 0, komponen_darah_ml: 0 };
  cairanKeluar: any = { perdarahan_ml: 0, urin_ml: 0, lain_ml: 0 };

  commonDrugs = [
    "Fentanyl", "Propofol", "Midazolam", "Ketamine", "Atracurium",
    "Rocuronium", "Vecuronium", "Succinylcholine", "Neostigmine",
    "Atropine", "Ephedrine", "Phenylephrine", "Norepinephrine",
    "Ondansetron", "Dexamethasone", "Ketorolac", "Morphine",
    "Bupivacaine", "Lidocaine", "Sevoflurane", "Isoflurane",
  ];

  ruteOptions = [
    { text: "IV Bolus", value: "iv_bolus" },
    { text: "IV Drip", value: "iv_drip" },
    { text: "IM", value: "im" },
    { text: "SC", value: "sc" },
    { text: "Inhalasi", value: "inhalasi" },
    { text: "Epidural", value: "epidural" },
    { text: "Intratekal", value: "intratekal" },
    { text: "Topikal", value: "topikal" },
    { text: "Lainnya", value: "lainnya" },
  ];

  obatHeaders = [
    { text: "Mnt", value: "menit_ke", width: "50px" },
    { text: "Waktu", value: "waktu", width: "80px" },
    { text: "Obat", value: "nama_obat" },
    { text: "Dosis", value: "dosis", width: "100px" },
    { text: "Rute", value: "rute", width: "90px" },
    { text: "Drip", value: "kecepatan_drip", width: "90px" },
    { text: "Ket", value: "keterangan" },
    { text: "", value: "actions", sortable: false, width: "70px" },
  ];

  mounted() {
    this.loadCairan();
  }

  @Watch("pemantauan")
  onPemantauanChanged() {
    if (this.dirty) return;
    this.loadCairan();
  }

  @Watch("cairanMasuk", { deep: true })
  @Watch("cairanKeluar", { deep: true })
  onCairanChanged() {
    this.dirty = true;
  }

  loadCairan() {
    if (this.pemantauan?.cairan_masuk) {
      this.cairanMasuk = { ...this.cairanMasuk, ...this.pemantauan.cairan_masuk };
    }
    if (this.pemantauan?.cairan_keluar) {
      this.cairanKeluar = { ...this.cairanKeluar, ...this.pemantauan.cairan_keluar };
    }
    this.$nextTick(() => {
      this.dirty = false;
    });
  }

  get sortedObats() {
    if (!this.pemantauan?.obats) return [];
    return [...this.pemantauan.obats].sort((a: any, b: any) => (a.menit_ke ?? 0) - (b.menit_ke ?? 0));
  }

  get kumulatifData() {
    return this.pemantauan?.kumulatif_obat_computed || [];
  }

  get totalMasuk() {
    return (this.cairanMasuk.kristaloid_ml || 0) + (this.cairanMasuk.koloid_ml || 0) + (this.cairanMasuk.komponen_darah_ml || 0);
  }

  get totalKeluar() {
    return (this.cairanKeluar.perdarahan_ml || 0) + (this.cairanKeluar.urin_ml || 0) + (this.cairanKeluar.lain_ml || 0);
  }

  get balanceMl() {
    if (this.totalMasuk === 0 && this.totalKeluar === 0) return null;
    return this.totalMasuk - this.totalKeluar;
  }

  get waktuObat(): Date | null {
    return this.obatForm.waktu ? moment(this.obatForm.waktu).toDate() : null;
  }

  set waktuObat(val: Date | null) {
    this.obatForm.waktu = val ? moment(val).format("YYYY-MM-DDTHH:mm") : "";
  }

  formatTime(dt: string) {
    return dt ? moment(dt).format("HH:mm") : "-";
  }

  openObatDialog() {
    this.editingObat = null;
    const now = moment().format("YYYY-MM-DDTHH:mm");
    this.obatForm = {
      waktu: now, nama_obat: "", dosis: "", rute: "iv_bolus",
      kecepatan_drip: "", keterangan: "",
    };
    this.dialogObat = true;
  }

  editObat(item: any) {
    this.editingObat = item;
    this.obatForm = {
      waktu: item.waktu ? moment(item.waktu).format("YYYY-MM-DDTHH:mm") : "",
      nama_obat: item.nama_obat,
      dosis: item.dosis,
      rute: item.rute,
      kecepatan_drip: item.kecepatan_drip || "",
      keterangan: item.keterangan || "",
    };
    this.dialogObat = true;
  }

  async simpanObat() {
    if (!(this.$refs.obatForm as any).validate()) return;
    this.savingObat = true;
    try {
      let resp;
      if (this.editingObat) {
        resp = await PemantauanAnestesiSvc.updateObat(this.pemantauan.id, this.editingObat.id, this.obatForm);
      } else {
        resp = await PemantauanAnestesiSvc.addObat(this.pemantauan.id, this.obatForm);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Obat berhasil disimpan");
        this.dialogObat = false;
        this.$emit("refresh");
      }
    } catch {
      // handled by service
    }
    this.savingObat = false;
  }

  async hapusObat(item: any) {
    if (!confirm("Hapus data obat ini?")) return;
    try {
      const resp = await PemantauanAnestesiSvc.deleteObat(this.pemantauan.id, item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Obat berhasil dihapus");
        this.$emit("refresh");
      }
    } catch {
      // handled by service
    }
  }

  validateStep(): boolean {
    return true;
  }

  collectPayload(): any {
    return {
      cairan_masuk: {
        ...this.cairanMasuk,
        total_masuk_ml: this.totalMasuk,
      },
      cairan_keluar: {
        ...this.cairanKeluar,
        total_keluar_ml: this.totalKeluar,
      },
    };
  }

  isDirty(): boolean {
    return this.dirty;
  }

  markSaved() {
    this.dirty = false;
  }
}
